import { Groups, Person } from "@mui/icons-material";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { FarmerLevelHclNewUi } from "./FarmerLevelHclNewUi";
import { FGDLevelHclNewUi } from "./FGDLevelHclNewUi";
import LocationFilter from "./LocationFilters";
import React from "react";

export const FieldActivitiesNewUi = ({ orgName, firstDistrict }) => {
  const [activeCard, setActiveCard] = useState(null);
  const [CropCode, setCropCode] = useState(null);
  const [CropLabel, setCropLabel] = useState(null);
  const [CropListMaster, setCropMasterList] = useState([]);
  const [ids, setIds] = useState([]);

  const [filters, setFilters] = useState({
    district: null,
    block: null,
    grampanchayat: null,
    majra: null,
  });

  const handleLocationChange = (newFilters) => {
    setFilters(newFilters);
  };

  useEffect(() => {
    fetch(
      "https://lc-research-projects.s3.ap-south-1.amazonaws.com/maati/baseline/crop_level_1_en.json"
    )
      .then((res) => res.json())
      .then((data) => setCropMasterList(data?.data?.crop_name));
  }, []);

  const optionCrop = React.useMemo(() => {
    if (!CropListMaster) return [];

    const groups = CropListMaster?.reduce((acc, crop) => {
      const groupName = crop.crop_group || "Others";
      if (!acc[groupName]) acc[groupName] = [];
      acc[groupName].push({
        label: crop.crop_name,
        value: crop.crop_name,
      });
      return acc;
    }, {});

    return Object.keys(groups).map((group) => ({
      label: group,
      options: groups[group],
    }));
  }, [CropListMaster]);

  useEffect(() => {
    if (!CropLabel) return;

    fetch(
      `https://agrani-cms.leadsconnect.in/api/farmer-level-crops?filters[crop_name]=${CropLabel}&fields[1]=farmer_id&sort[0]=createdAt:desc&pagination[pageSize]=100`
    ).then((res) =>
      res.json().then((data) => setIds(data?.data?.map((d) => d.farmer_id)))
    );
  }, [CropLabel]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };

  return (
    <div className="p-0 mb-5">
      {activeCard === null && (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "center" },
            alignItems: "center",
            gap: { xs: 2, sm: 3 },
            mt: 5,
          }}
        >
          <Card
            onClick={() => setActiveCard("Farmer Level")}
            sx={{
              minWidth: 220,
              px: 2,
              py: 1,
              width: { xs: "80%", sm: "auto" },
              background:
                activeCard === "Farmer Level"
                  ? "linear-gradient(135deg, #ffcc80, #ffb74d)"
                  : "linear-gradient(135deg, #fff3e0, #ffe0b2)",
              color: "#333",
              borderRadius: "20px",
              boxShadow: 3,
              cursor: "pointer",
              transition: "0.3s",
              textAlign: "center",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: 6,
              },
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Person fontSize="large" />
              <Typography variant="subtitle1" fontWeight={600}>
                Farmer Level
              </Typography>
            </CardContent>
          </Card>

          <Card
            onClick={() => setActiveCard("FGD Level")}
            sx={{
              minWidth: 220,
              px: 2,
              py: 1,
              width: { xs: "80%", sm: "auto" },
              background:
                activeCard === "FGD Level"
                  ? "linear-gradient(135deg, #a5d6a7, #81c784)"
                  : "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
              color: "#333",
              borderRadius: "20px",
              boxShadow: 3,
              cursor: "pointer",
              transition: "0.3s",
              textAlign: "center",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: 6,
              },
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Groups fontSize="large" />
              <Typography variant="subtitle1" fontWeight={600}>
                FGD Level
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}

      {activeCard && (
        <Row className="mt-3 align-items-center position-relative d-flex flex-column flex-lg-row">
          <Col xs="12" lg="9" className="mb-2 mb-lg-0">
            <LocationFilter
              onChange={handleLocationChange}
              majraRequired={false}
              firstDistrict={firstDistrict}
            />
          </Col>

          <Col xs="12" lg="3" className="mb-2">
            <Select
              value={
                CropCode && CropLabel
                  ? { value: CropCode, label: CropLabel }
                  : null
              }
              onChange={(option) => {
                if (option) {
                  setCropCode(option.value);
                  setCropLabel(option.label);
                } else {
                  setCropCode(null);
                  setCropLabel(null);
                }
              }}
              options={optionCrop}
              placeholder="Select Crop"
              styles={customStyles}
              isClearable
            />
          </Col>

          <div className="text-end ">
            <span
              style={{
                color: "steelblue",
                textDecoration: "underline",
                cursor: "pointer",
                position: "absolute",
                top: "-25px",
                right: "10px",
              }}
              onClick={() => {
                setActiveCard(null);
                setFilters({
                  district: null,
                  block: null,
                  grampanchayat: null,
                  majra: null,
                });
                setCropCode(null);
                setCropLabel(null);
                setIds([]);
              }}
            >
              Back
            </span>
          </div>
        </Row>
      )}

      {activeCard === "Farmer Level" && (
        <FarmerLevelHclNewUi
          ids={ids}
          crop={CropLabel}
          districtValue={filters.district?.value}
          blockValue={filters.block?.value}
          GpValue={filters.grampanchayat?.value}
        />
      )}

      {activeCard === "FGD Level" && (
        <FGDLevelHclNewUi
          orgName={orgName}
          ids={ids}
          crop={CropLabel}
          districtValue={filters.district?.value}
          blockValue={filters.block?.value}
          GpValue={filters.grampanchayat?.value}
        />
      )}
    </div>
  );
};
